import React, { useEffect, useState } from 'react';
import { MainBox } from '../../styles/contentsStyles';

import { handleImgError, textSilce } from '../../constants/index';
import Skeleton from '../../components/skeleton/Skeleton';
import LazyImages from '../../pages/common/LazyImages';

const ContentsMainBox = ({
  data,
  width,
  margin,
  row,
  goDetail,
  imgOpacity,
  freePlayBtn,
  playBtn,
  animation,
  contetentWidth,
  contetentHeight,
  type,
}) => {
  const typeCheckRender = () => {
    let result;
    let renderData = data;
    if (type === 'program') renderData = renderData?.episode;

    switch (type) {
      case 'vod':
        result = (
          <div>
            <h3>{`${renderData?.episodeNo ? `${renderData?.episodeNo} 화` : ''} ${renderData?.title}`}</h3>
            <p>{renderData?.programTitle}</p>
          </div>
        );
        break;
      case 'program':
        result = (
          <div>
            <h3>{`${renderData?.episodeNo ? `${renderData?.episodeNo} 화` : ''} ${renderData?.title}`}</h3>
            <p>{renderData?.programTitle}</p>
          </div>
        );
        break;
      case 'main-vod':
        result = (
          <section>
            <div>
              <h3>{`${renderData?.episodeNo ? `${renderData?.episodeNo} 화` : ''}`}</h3>
              <p>{renderData?.title && textSilce(renderData?.title, 15)}</p>
            </div>
            <div className='main-vod-contents-box'>
              <img src={renderData?.programImage ? renderData?.programImage : ''} alt='' onError={e => handleImgError(e, 'icon')} />
              <p>{renderData?.programTitle}</p>
            </div>
          </section>
        );
        break;
      case 'rec-vod':
        result = (
          <section>
            <div>
              <h3>{`${renderData?.episodeNo ? `${renderData?.episodeNo} 화` : ''}`}</h3>
              <p>{renderData?.title && textSilce(renderData?.title, 15)}</p>
            </div>
          </section>
        );
        break;
    }

    return result;
  };

  const goDetailPage = () => {
    if (!data?.id) return;

    goDetail(data);
  };

  const [imgUrl, setImgUrl] = useState('');
  useEffect(() => {
    if (data?.img) {
      if (data.img instanceof Array) {
        setImgUrl(data.img[0].url);
      } else {
        setImgUrl(data.img.url);
      }
    } else {
      if (data.episode?.img instanceof Array) {
        setImgUrl(data.episode?.img[0].url);
      } else {
        setImgUrl(data.episode?.img.url);
      }
    }
  }, [data]);

  return (
    <MainBox
      width={width}
      margin={margin}
      row={row}
      type={type}
      contetentWidth={contetentWidth}
      contetentHeight={contetentHeight}
      onClick={goDetailPage}
      animation={animation}
      imgOpacity={imgOpacity}
    >
      {data?.id ? (
        <>
          <div className='contents_main_img_Box' style={{ position: 'relative' }}>
            <LazyImages src={imgUrl} alt={data?.img?.name} />
            {freePlayBtn && <img alt='playBtn' className='playBtn' src={`/assets/Ftv/Icon/ic_playBtn.png`} />}
          </div>

          <div className='contents_main_Box'>
            {playBtn && <img alt='playBtn' className='playBtn' src={`/assets/Ftv/Icon/ic_playBtn.png`} />}

            {/* 타입마다 내용 다르게. */}
            {typeCheckRender()}
          </div>
        </>
      ) : (
        <Skeleton width='100%' height='100%' margin='0' />
      )}
    </MainBox>
  );
};

export default ContentsMainBox;
